// Persetujuan pendaftar & fitur per klien (2026-10-12).
// Pendaftar baru berstatus 'pending' → admin memilih paket (preset fitur ikut terisi), masa aktif,
// centang fitur, dan batas channel per platform (kosong = ikut paket), lalu Setujui / Tolak.
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'https://api.starhubcreative.id';
const card = { background: '#FFFFFF', border: '1px solid rgba(11,11,15,0.78)', borderRadius: 12, padding: 18, marginBottom: 14 };
const inp = { background: '#FFFFFF', border: '1px solid rgba(11,11,15,0.78)', color: '#0B0B0F', borderRadius: 8, padding: '8px 10px', fontSize: 13, boxSizing: 'border-box' };
const PAKET = ['starter', 'medium', 'standard', 'mega'];
const LABEL_PLATFORM = { youtube: 'YouTube', tiktok: 'TikTok', instagram: 'Instagram' };

function useMeta() {
  const [meta, setMeta] = useState(null);
  useEffect(() => { axios.get(`${API}/api/admin/fitur-meta`).then(r => setMeta(r.data)).catch(() => {}); }, []);
  return meta;
}

function FormFitur({ meta, fitur, setFitur, batas, setBatas }) {
  return (
    <>
      <div style={{ fontSize: 12, color: '#5B5149', margin: '10px 0 6px' }}>Fitur yang dibuka <span style={{ opacity: .7 }}>(fitur inti — upload & distribusi YouTube, riwayat, panduan — selalu terbuka)</span></div>
      {/* Dikelompokkan mengikuti menu dashboard (2026-10-25); meta lama tanpa grup tetap tampil sebagai satu kelompok. */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {(meta.grup || [{ key: '', label: 'Fitur' }]).map(g => {
          const diGrup = meta.fitur.filter(f => (f.grup || '') === g.key);
          const isi = diGrup;
          // Fitur rinci (2026-10-25): induk yang punya sub tampil satu baris penuh, sub-nya menjorok tepat di bawahnya.
          const akar = diGrup.filter(f => !f.induk || !diGrup.some(x => x.key === f.induk));
          const nyala = isi.filter(f => fitur[f.key] && (!f.induk || fitur[f.induk])).length;
          const setSemua = v => setFitur({ ...fitur, ...Object.fromEntries(isi.map(f => [f.key, v])) });
          const kotak = f => {
            const indukMati = f.induk && !fitur[f.induk];
            const subs = meta.fitur.filter(x => x.induk === f.key);
            const ubah = v => setFitur({ ...fitur, [f.key]: v, ...(v && subs.length ? Object.fromEntries(subs.map(x => [x.key, true])) : {}) });
            const induk = f.induk && meta.fitur.find(x => x.key === f.induk);
            return (
              <label key={f.key} style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', gap: 8, fontSize: 13, color: '#1F1A17', cursor: 'pointer', padding: '6px 8px', borderRadius: 8, background: fitur[f.key] && !indukMati ? 'rgba(255,90,31,0.14)' : 'transparent', opacity: indukMati ? 0.5 : 1 }}>
                <input type="checkbox" checked={!!fitur[f.key]} onChange={e => ubah(e.target.checked)} style={{ width: 16, height: 16, margin: '2px 0 0', flex: '0 0 auto' }} />
                <span style={{ textAlign: 'left', display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <span style={{ fontWeight: subs.length ? 600 : 400 }}>{f.label}</span>
                  {f.ket && <span style={{ fontSize: 11, color: '#5B5149', lineHeight: 1.35 }}>{f.ket}</span>}
                  {indukMati && <span style={{ fontSize: 11, color: '#B45309' }}>Aktifkan "{induk ? induk.label : f.induk}" dulu</span>}
                </span>
              </label>
            );
          };
          return (
            <div key={g.key} style={{ border: '1px solid rgba(11,11,15,0.18)', borderRadius: 10, padding: '8px 10px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                <span style={{ fontSize: 12, fontWeight: 700, color: '#1F1A17' }}>{g.label} <span style={{ fontWeight: 400, color: '#5B5149' }}>({nyala}/{isi.length})</span></span>
                {isi.length > 1 && (
                  <span style={{ display: 'flex', gap: 6 }}>
                    <button type="button" onClick={() => setSemua(true)} style={{ background: 'transparent', border: '1px solid rgba(11,11,15,0.35)', color: '#3A322C', borderRadius: 6, padding: '2px 8px', fontSize: 11, cursor: 'pointer' }}>Semua</button>
                    <button type="button" onClick={() => setSemua(false)} style={{ background: 'transparent', border: '1px solid rgba(11,11,15,0.35)', color: '#3A322C', borderRadius: 6, padding: '2px 8px', fontSize: 11, cursor: 'pointer' }}>Kosongkan</button>
                  </span>
                )}
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 6 }}>
                {akar.map(f => {
                  const subs = diGrup.filter(x => x.induk === f.key);
                  if (!subs.length) return kotak(f);
                  return (
                    <div key={f.key} style={{ gridColumn: '1 / -1', display: 'flex', flexDirection: 'column', gap: 6 }}>
                      {kotak(f)}
                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 6, marginLeft: 18, paddingLeft: 10, borderLeft: '2px solid rgba(11,11,15,0.18)' }}>
                        {subs.map(kotak)}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
      <div style={{ fontSize: 12, color: '#5B5149', margin: '12px 0 6px' }}>Batas channel per platform <span style={{ opacity: .7 }}>(kosongkan = ikut paket)</span></div>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        {meta.platform.map(p => (
          <label key={p} style={{ fontSize: 12, color: '#3A322C', display: 'flex', flexDirection: 'column', gap: 4 }}>
            {LABEL_PLATFORM[p] || p}
            <input type="number" min="0" max="1000" placeholder="ikut paket" value={batas[p] ?? ''} style={{ ...inp, width: 120 }}
              onChange={e => setBatas({ ...batas, [p]: e.target.value === '' ? '' : Number(e.target.value) })} />
          </label>
        ))}
      </div>
    </>
  );
}

export function PendaftarBaru({ onChanged }) {
  const meta = useMeta();
  const [list, setList] = useState([]);
  const [buka, setBuka] = useState(null); // id yang sedang diproses
  const [paket, setPaket] = useState('starter');
  const [hari, setHari] = useState(30);
  const [fitur, setFitur] = useState({});
  const [batas, setBatas] = useState({});
  const [alasan, setAlasan] = useState('');
  const [pesan, setPesan] = useState('');
  const [sibuk, setSibuk] = useState(false);

  const muat = () => axios.get(`${API}/api/admin/clients-pending`).then(r => setList(r.data || [])).catch(() => setList([]));
  useEffect(() => { muat(); }, []);
  const pilihPaket = p => { setPaket(p); if (meta) setFitur(Object.fromEntries((meta.preset[p] || []).map(k => [k, true]))); };
  const mulai = id => { setBuka(id); setAlasan(''); setBatas({}); setHari(30); pilihPaket('starter'); setPesan(''); };

  async function setujui(c) {
    setSibuk(true);
    try {
      const r = await axios.post(`${API}/api/admin/clients/${c.id}/approve`, { plan: paket, days: hari, features: fitur, channel_limits: batas });
      setPesan('✅ ' + r.data.message); setBuka(null); muat(); onChanged && onChanged();
    } catch (e) { setPesan('❌ ' + (e.response?.data?.error || 'Gagal menyetujui')); }
    setSibuk(false);
  }
  async function tolak(c) {
    setSibuk(true);
    try {
      const r = await axios.post(`${API}/api/admin/clients/${c.id}/reject`, { reason: alasan });
      setPesan('🚫 ' + r.data.message); setBuka(null); muat(); onChanged && onChanged();
    } catch (e) { setPesan('❌ ' + (e.response?.data?.error || 'Gagal menolak')); }
    setSibuk(false);
  }

  const menunggu = list.filter(c => c.status === 'pending'), ditolak = list.filter(c => c.status === 'rejected');
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 10 }}>
        <h1 style={{ fontSize: 20, fontWeight: 700, color: '#0B0B0F' }}>Pendaftar baru ({menunggu.length})</h1>
        <button onClick={muat} style={{ background: 'transparent', border: '1px solid rgba(11,11,15,0.78)', color: '#5B5149', padding: '8px 14px', borderRadius: 8, cursor: 'pointer', fontSize: 13 }}>🔄 Refresh</button>
      </div>
      {pesan && <div style={{ ...card, padding: 12, fontSize: 13, color: '#0B0B0F' }}>{pesan}</div>}
      {menunggu.length === 0 && <div style={{ ...card, color: '#5B5149', fontSize: 13 }}>Tidak ada pendaftar yang menunggu persetujuan.</div>}
      {[...menunggu, ...ditolak].map(c => (
        <div key={c.id} style={{ ...card, opacity: c.status === 'rejected' && buka !== c.id ? 0.7 : 1 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap' }}>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: '#0B0B0F' }}>{c.name} {c.status === 'rejected' && <span style={{ fontSize: 11, color: '#ef4444', border: '1px solid #ef4444', borderRadius: 4, padding: '1px 6px', marginLeft: 6 }}>DITOLAK</span>}</div>
              <div style={{ fontSize: 12, color: '#5B5149', overflowWrap: 'anywhere' }}>{c.email} · {c.phone || '-'}{c.artist_name ? ` · artis: ${c.artist_name}` : ''}</div>
              <div style={{ fontSize: 11, color: '#7A6E64' }}>Daftar {new Date(c.created_at).toLocaleString('id-ID')}{c.referred_by ? ` · referral ${c.referred_by}` : ''}{c.rejected_reason ? ` · alasan tolak: ${c.rejected_reason}` : ''}</div>
            </div>
            {buka !== c.id && <button onClick={() => mulai(c.id)} style={{ background: 'linear-gradient(135deg,#FFB800 0%,#FF5A1F 45%,#FF2D2D 100%)', color: '#000', border: 'none', borderRadius: 8, padding: '8px 14px', fontWeight: 700, cursor: 'pointer', fontSize: 13, alignSelf: 'flex-start' }}>{c.status === 'rejected' ? 'Tinjau ulang' : 'Tinjau'}</button>}
          </div>
          {buka === c.id && meta && (
            <div style={{ marginTop: 12, borderTop: '1px solid rgba(11,11,15,0.78)', paddingTop: 12 }}>
              <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'flex-end' }}>
                <label style={{ fontSize: 12, color: '#3A322C', display: 'flex', flexDirection: 'column', gap: 4 }}>Paket
                  <select value={paket} onChange={e => pilihPaket(e.target.value)} style={inp}>{PAKET.map(p => <option key={p} value={p}>{p.toUpperCase()}</option>)}</select>
                </label>
                <label style={{ fontSize: 12, color: '#3A322C', display: 'flex', flexDirection: 'column', gap: 4 }}>Masa aktif (hari)
                  <input type="number" min="1" max="3650" value={hari} onChange={e => setHari(e.target.value)} style={{ ...inp, width: 110 }} />
                </label>
                <span style={{ fontSize: 11, color: '#7A6E64', paddingBottom: 8 }}>Ganti paket = centang fitur diisi ulang sesuai preset.</span>
              </div>
              <FormFitur meta={meta} fitur={fitur} setFitur={setFitur} batas={batas} setBatas={setBatas} />
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 14, alignItems: 'center' }}>
                <button disabled={sibuk} onClick={() => setujui(c)} style={{ background: '#00A86B', color: '#000', border: 'none', borderRadius: 8, padding: '9px 16px', fontWeight: 700, cursor: 'pointer', fontSize: 13 }}>✅ Setujui & aktifkan</button>
                <input placeholder="Alasan tolak (opsional)" value={alasan} onChange={e => setAlasan(e.target.value)} style={{ ...inp, flex: '1 1 180px' }} />
                {c.status !== 'rejected' && <button disabled={sibuk} onClick={() => tolak(c)} style={{ background: 'transparent', color: '#ef4444', border: '1px solid #ef4444', borderRadius: 8, padding: '9px 14px', cursor: 'pointer', fontSize: 13 }}>🚫 Tolak</button>}
                <button onClick={() => setBuka(null)} style={{ background: 'transparent', color: '#5B5149', border: '1px solid rgba(11,11,15,0.78)', borderRadius: 8, padding: '9px 14px', cursor: 'pointer', fontSize: 13 }}>Batal</button>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

/** Panel di detail klien: ubah fitur & batas channel klien yang sudah ada. */
export function FiturKlien({ client, onSaved }) {
  const meta = useMeta();
  const [fitur, setFitur] = useState(client?.fitur_efektif || {});
  const [batas, setBatas] = useState(() => Object.fromEntries(Object.entries(client?.batas_efektif || {}).map(([k, v]) => [k, v ?? ''])));
  const [pesan, setPesan] = useState('');
  useEffect(() => {
    setFitur(client?.fitur_efektif || {});
    setBatas(Object.fromEntries(Object.entries(client?.batas_efektif || {}).map(([k, v]) => [k, v ?? ''])));
  }, [client?.id]); // eslint-disable-line
  if (!meta || !client) return null;
  async function simpan() {
    try {
      const r = await axios.put(`${API}/api/admin/clients/${client.id}/fitur`, { features: fitur, channel_limits: batas });
      setPesan('✅ ' + r.data.message); onSaved && onSaved();
    } catch (e) { setPesan('❌ ' + (e.response?.data?.error || 'Gagal menyimpan')); }
  }
  return (
    <div style={card}>
      <h3 style={{ fontSize: 14, fontWeight: 600, color: '#0B0B0F', marginBottom: 4 }}>🧩 Fitur & batas channel</h3>
      {!client.features && <div style={{ fontSize: 11, color: '#5B5149' }}>Klien lama: semua fitur terbuka sampai diatur di sini.</div>}
      <FormFitur meta={meta} fitur={fitur} setFitur={setFitur} batas={batas} setBatas={setBatas} />
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginTop: 12, flexWrap: 'wrap' }}>
        <button onClick={simpan} style={{ background: 'linear-gradient(135deg,#FFB800 0%,#FF5A1F 45%,#FF2D2D 100%)', color: '#000', border: 'none', borderRadius: 8, padding: '9px 16px', fontWeight: 700, cursor: 'pointer', fontSize: 13 }}>Simpan fitur & batas</button>
        {pesan && <span style={{ fontSize: 12, color: '#1F1A17' }}>{pesan}</span>}
      </div>
    </div>
  );
}
